export function createAuthHeadersMiddleware({
  apiKey,
  getApiToken,
  getAccessToken,
  shouldSendAuth
}) {
  return next =>
    (url, init = {}) => {
      // Raw uploads (e.g. S3 presigned URLs) must not receive client auth headers —
      // S3 rejects requests with both presigned signature and Authorization header
      if (init.__rawUpload) {
        return next(url, init);
      }

      const headers = { ...(init.headers || {}) };

      headers['X-Api-Key'] = apiKey;

      const apiToken = getApiToken();
      if (apiToken) {
        headers['X-Api-Token'] = apiToken;
      }

      if (headers.Authorization === '') {
        delete headers.Authorization;
      } else if (shouldSendAuth()) {
        headers.Authorization = `Bearer ${getAccessToken()}`;
      }

      return next(url, { ...init, headers });
    };
}
